import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { CommonService } from './common.service';
import { GlobalVariable } from 'app/app.global';
import { ConsumeView, DataPackCompanyDetail, DataPackGroup, DataPackUserManagerModel, DataPackLine, DataPackValue } from 'app/models/start';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from '../utils/bind.component.service';

/**
 * @author Wesley Mascarenhas
 * @version $Id: consume.service.ts 84431 2018-04-03 19:47:47Z bernardo.d.siqueira $
 */
@Injectable()
export class ConsumeService extends CommonService {
  private localURL: string;
  private CONSUMER_PATH: string = '/datapackconsumption';
  private CONSUMER_PATH_5G: string = '/datapackconsumption5G';

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.CONSUMER_PATH;
  }

  public loadView(technology: string, startRow: number, fetchSize: number) {
    let url: string;

    //TODO: problema de permissão do iolos
    if(technology=="5G"){
      url = this.baseURL + this.CONSUMER_PATH_5G + '?action=loadView';
    }else{
      url = this.baseURL + this.CONSUMER_PATH + '?action=loadView';
    }

    //console.log("technology ==> " + technology);

    if(technology) {
      url += '&technology=' + technology;
    }
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public listGroups(technology:string, startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=listGroups';
    if(technology) {
      url += '&technology=' + technology;
    }
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public listLines(group: DataPackGroup, startRow: number, fetchSize: number) {
    return this.convertResponse(this.httpPost(this.localURL,{group:group,action:'listLines',startRow:startRow,fetchSize:fetchSize}));
  }

  public save(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }

  public loadGroupFilterData(group:DataPackGroup,startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=loadSelectedLineAndGroup';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpPost(this.localURL,{group:group,
                                                             action:'loadSelectedLineAndGroup',
                                                             technology:group.technology,
                                                             startRow:startRow,
                                                             fetchSize:fetchSize}));
  }

  public getGroupMoveLines(data: any) {
    let url: string;

    //TODO: problema de permissão do iolos
    if(data.group.technology=="5G"){
      url = this.baseURL + this.CONSUMER_PATH_5G;
    }else{
      url = this.baseURL + this.CONSUMER_PATH ;
    }


    return this.convertResponse(this.httpPost(url, data));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/consume.service.ts